module.exports = __webpack_public_path__ + "components/rewards/no-ads/static/logo-cb848ee88b5e87ea0a9143129f624a66.jpg";